module.exports = __webpack_public_path__ + "img/title-right.70533c45.png";